import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  Context,
} from 'react';
import { observer } from 'mobx-react-lite';

import { Grid, Paper, Typography } from '@material-ui/core';
import {
  InputContainer,
  listRemoveBtnStyle,
  listSelectBtnStyle,
} from './styles';
import { Button, CloseButton } from '../../generators/FormGenerator/styles';

import { FormStoreContext, FormStore } from '../../store/FormStore';

import { PropListInput } from '../../store/inputs/PropListInput';

import { InputType } from '../../store/inputs/types';
import { TextInput } from '../../store/inputs/TextInput';
import CTextInput from './CTextInput';
import { BooleanInput } from '../../store/inputs/BooleanInput';
import CBooleanInput from './CBooleanInput';
import { TextListInput } from '../../store/inputs/TextListInput';
import CTextListInput from './CTextListInput';

const CPropListInput = observer(({ item }: { item: PropListInput }) => {
  const { label, value, onChangeValue, disabled, isKey, isEdit, props } = item;
  const [propArray, setProps] = useState<Record<string, any>[]>([]);

  const context = useCallback(() => {
    return FormStoreContext(
      props.map((prop) => {
        switch (prop.dataType) {
          case 'string':
            return new TextInput({...prop, onChange: () => {}, clearValue: () => {}, toggleDisabled: () => {}});
          case 'boolean':
            return new BooleanInput({...prop, onChange: () => {}, clearValue: () => {}, toggleDisabled: () => {}});
          case '[]string':
            return new TextListInput({...prop, onChange: () => {}, clearValue: () => {}, toggleDisabled: () => {}});
          default:
            return new TextInput({...prop, onChange: () => {}, clearValue: () => {}, toggleDisabled: () => {}});
        }
      }),
    );
  }, [props]);
  const Forms: FormStore = useContext(context() as Context<FormStore>);
  const { inputs } = Forms;

  useEffect(() => {
    // Zero all inputs for creating
    inputs.forEach((input) => {
      input.value = null;
      input.selectorValue = null;
    });
  }, [inputs]);

  useEffect(() => {
    setProps(value || []);
  }, [value]);

  // add a new prop to the array
  const addProp = () => {
    const data = Forms.getData();

    if (data.defaultValue !== null && data.defaultValue === '') {
      data.defaultValue = null;
    } else if (data.defaultValue !== null) {
      switch (data.dataType) {
        case 'string':
          break;
        case 'boolean':
          if (
            typeof data.defaultValue === 'string' ||
            data.defaultValue instanceof String
          ) {
            data.defaultValue = data.defaultValue === 'true';
          }
          break;
        case 'number':
          data.defaultValue = Number(data.defaultValue);
          break;
        case '[]string':
          if (
            typeof data.defaultValue === 'string' ||
            data.defaultValue instanceof String
          ) {
            data.defaultValue = data.defaultValue.substring(
              1,
              data.defaultValue.length - 1,
            );
            data.defaultValue = data.defaultValue.split(',');
            data.defaultValue = data.defaultValue.map((str: string) =>
              str.trim().substring(1, str.trim().length - 1),
            );
          }
          break;
        case '[]number':
          if (
            typeof data.defaultValue === 'string' ||
            data.defaultValue instanceof String
          ) {
            data.defaultValue = data.defaultValue.substring(
              1,
              data.defaultValue.length - 1,
            );
            data.defaultValue = data.defaultValue.split(',');
            data.defaultValue = data.defaultValue.map((str: string) =>
              Number(str),
            );
          }
          break;
        default:
      }
    }

    if (!propArray.find((prop: Record<string, any>) => prop.tag === data.tag)) {
      const newProps: Record<string, any>[] = [...propArray, data];
      onChangeValue(newProps);
    } else {
      const index = propArray.findIndex(
        (prp: Record<string, any>) => prp.tag === data.tag,
      );
      const newProps = propArray;
      newProps[index] = data;
      onChangeValue(newProps);
    }
    Forms.clearInputs();
  };

  // remove an asset
  const removeProp = (prop: Record<string, any>) => {
    const removeIndex = propArray.findIndex(
      (prp: Record<string, any>) => prp.tag === prop.tag,
    );

    if (removeIndex >= 0) {
      const newProps = [...propArray];
      newProps.splice(removeIndex, 1);
      onChangeValue(newProps);
    }
  };

  // remove an asset
  const selectProp = (prop: Record<string, any>) => {
    Forms.inputs.forEach((input) => {
      input.value = prop[input.tag];
      input.selectorValue = null;
    });
  };

  return (
    <Grid container wrap="wrap" spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <Paper style={{ padding: '5px', marginTop: '2%', marginBottom: '2%' }}>
          <InputContainer>
            <Typography style={{ color: '#777' }}>{label}</Typography>
            {inputs.map((prop: InputType) => {
              return (
                <>
                  {prop.dataType === 'string' && (
                    <CTextInput key={prop.tag} item={prop as TextInput} />
                  )}
                  {prop.dataType === 'boolean' && (
                    <CBooleanInput key={prop.tag} item={prop as BooleanInput} />
                  )}
                  {prop.dataType === '[]string' && (
                    <CTextListInput
                      key={prop.tag}
                      item={prop as TextListInput}
                    />
                  )}
                </>
              );
            })}
            {propArray && propArray.length
              ? propArray.map((prp, index) => {
                  return (
                    <>
                      <Button
                        key={`${prp.tag}${index}`}
                        style={listSelectBtnStyle}
                        onClick={() => selectProp(prp)}
                        disabled={disabled || (isKey && isEdit)}
                      >
                        {prp.tag}
                      </Button>
                      <CloseButton
                        key={`${prp.tag}${index}-delete`}
                        style={listRemoveBtnStyle}
                        onClick={() => removeProp(prp)}
                        disabled={disabled || (isKey && isEdit)}
                      >
                        <i className="bx bx-x-circle" style={{ color: '#aa0000', fontSize: '20px' }}></i>
                      </CloseButton>
                    </>
                  );
                })
              : null}
          </InputContainer>
          <Button
            style={{ margin: '0 0 10px 5px' }}
            onClick={() => addProp()}
            disabled={disabled || (isKey && isEdit)}
          >
            Add / Update
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
});

export default CPropListInput;
